import { methodGet, methodPost, methodDelete, methodPut, methodPatch } from "./methods";
import { API_INFO } from "../constants";

export const getInvoices = async (payload) => {
  const url = API_INFO + `invoices/invoices/`;
  return methodGet(url, payload);
};

export const getAllInvoicesNotPaginated = async () => {
  const url = API_INFO + `invoices/invoices/all-invoices-not-paginated`;
  return methodGet(url);
};

export async function getDetailInvoice(id) {
  const url = API_INFO + `invoices/invoices/${id}/`;
  return methodGet(url);
}

export async function createInvoice(payload) {
  const url = API_INFO + 'invoices/invoices/';
  return methodPost(url, payload);
}

export const editInvoice = async (id, payload) => {
  const url = API_INFO + `invoices/invoices/${id}/`;
  return methodPatch(url, payload);
};

export const getPromotionalCodes = async (payload) => {
  const url = API_INFO + `invoices/promo-codes/`;
  return methodGet(url, payload);
};

export async function getPromoCode(id) {
  const url = API_INFO + `invoices/promo-codes/${id}/`;
  return methodGet(url);
}

export async function createPromoCode(payload) {
  const url = API_INFO + 'invoices/promo-codes/';
  return methodPost(url, payload);
}

export async function deletePromoCode(id) {
  const url = API_INFO + `invoices/promo-codes/${id}/`;
  return methodDelete(url, {});
}

export const editPromoCode = async (payload, id) => {
  const url = API_INFO + `invoices/promo-codes/${id}/`;
  return methodPut(url, payload);
};

export const createGiftCardCoupon = async (payload) => {
  const url = API_INFO + `invoices/promo-codes/create-gift-card/`;
  return methodPost(url, payload)
}
